module.exports = __webpack_public_path__ + "img/Secteur.31a5b86b.svg";